import React from 'react'
import {compose} from 'ramda'
import {translate} from '@modifi/plugin-i18n'
import {TaskCategory} from '@modifi/enums'

import CategoryFilter, {CategoryFilterProps} from './CategoryFilter'
import {FilterOption} from '../../ui/filter'
import {TranslateFn} from '../../types/i18n'

export const bsrTasks = [
  TaskCategory.TRADE_PARTNER_INSURANCE_LIMIT_FOLLOW_UP,
  TaskCategory.TRADE_PARTNER_INSURANCE_LIMIT_REALLOCATION,
  TaskCategory.TRADE_PARTNER_INSURANCE_LIMIT_HIGH_AMOUNT_APPLICATION,
  TaskCategory.TRADE_PARTNER_INSURANCE_LIMIT_UPDATE_APPLICATION,
  TaskCategory.TRADE_PARTNER_INSURANCE_LIMIT_MEDIUM_AMOUNT_APPLICATION,
  'TRADE_PARTNER_ALLOCATED_LIMIT_CHANGE_REQUEST',
]

export const financialTasks = [
  TaskCategory.COMPANY_FINANCIAL_REVIEW,
  TaskCategory.COMPANY_GROUP_FINANCIAL_REVIEW,
]

export const getTaskGroupOptions = (t: TranslateFn): FilterOption[] => [
  {
    label: t('tasks.group.all.label'),
    value: '',
    children: [
      {
        label: t('tasks.group.bsr.label'),
        value: bsrTasks.sort().join(),
        children: bsrTasks?.map(bsrTask => ({
          label: t(`tasks.filter.category.${bsrTask}.label`),
          value: bsrTask,
        })),
      },
      {
        label: t('tasks.group.financial-docs.label'),
        value: financialTasks.sort().join(),
        children: financialTasks?.map(bsrTask => ({
          label: t(`tasks.filter.category.${bsrTask}.label`),
          value: bsrTask,
        })),
      },
    ],
  },
]

type TaskGroupFilterProps = Omit<CategoryFilterProps, 'filterKey' | 'options'> & {
  t: TranslateFn
}

const TaskGroupFilter: React.FC<TaskGroupFilterProps> = ({t, ...restFilterProps}) => (
  <CategoryFilter
    filterKey="filter.category"
    options={getTaskGroupOptions(t)}
    {...restFilterProps}
  />
)

export default compose(translate('kartavya'))(TaskGroupFilter)
